// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyEditAmenitiesV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyEditHasAirConditioningUtilityIncludedV2RequestDto,
  UserPropertyEditHasAssistedLivingV2RequestDto,
  UserPropertyEditHasAttachedGarageParkingV2RequestDto,
  UserPropertyEditHasBarbecueV2RequestDto,
  UserPropertyEditHasBasketballSportCourtV2RequestDto,
  UserPropertyEditHasBicycleStorageV2RequestDto,
  UserPropertyEditHasBocceSportCourtV2RequestDto,
  UserPropertyEditHasBuildingWideWirelessV2RequestDto,
  UserPropertyEditHasBusinessCenterCommunityRoomV2RequestDto,
  UserPropertyEditHasCableTvUtilityIncludedV2RequestDto,
  UserPropertyEditHasCableTvV2RequestDto,
  UserPropertyEditHasCarpetFloorCoveringV2RequestDto,
  UserPropertyEditHasCeilingFanV2RequestDto,
  UserPropertyEditHasCentralAirConditioningV2RequestDto,
  UserPropertyEditHasCityViewV2RequestDto,
  UserPropertyEditHasClubHouseCommunityRoomV2RequestDto,
  UserPropertyEditHasConcreteFloorCoveringV2RequestDto,
  UserPropertyEditHasConferenceRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasControlledAccessSecurityV2RequestDto,
  UserPropertyEditHasConvectionOvenApplianceV2RequestDto,
  UserPropertyEditHasCoveredParkingParkingV2RequestDto,
  UserPropertyEditHasDeckOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasDetachedGarageParkingV2RequestDto,
  UserPropertyEditHasDisabledAccessV2RequestDto,
  UserPropertyEditHasDishwasherApplianceV2RequestDto,
  UserPropertyEditHasDoormanSecurityV2RequestDto,
  UserPropertyEditHasDoubleOvenApplianceV2RequestDto,
  UserPropertyEditHasDryCleaningDropOffV2RequestDto,
  UserPropertyEditHasElectricHeatingSourceV2RequestDto,
  UserPropertyEditHasElectricityUtilityIncludedV2RequestDto,
  UserPropertyEditHasElevatorV2RequestDto,
  UserPropertyEditHasFireplaceV2RequestDto,
  UserPropertyEditHasFitnessCenterCommunityRoomV2RequestDto,
  UserPropertyEditHasFlexibleLeaseLengthsV2RequestDto,
  UserPropertyEditHasFreezerApplianceV2RequestDto,
  UserPropertyEditHasGameRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasGarbageDisposalApplianceV2RequestDto,
  UserPropertyEditHasGarbageUtilityIncludedV2RequestDto,
  UserPropertyEditHasGardenOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasGasHeatingSourceV2RequestDto,
  UserPropertyEditHasGasUtilityIncludedV2RequestDto,
  UserPropertyEditHasGatedEntrySecurityV2RequestDto,
  UserPropertyEditHasGazeboOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasGolfCourseViewV2RequestDto,
  UserPropertyEditHasGuestSuiteV2RequestDto,
  UserPropertyEditHasHardwoodFloorCoveringV2RequestDto,
  UserPropertyEditHasHeatingUtilityIncludedV2RequestDto,
  UserPropertyEditHasHeatPumpHeatingSourceV2RequestDto,
  UserPropertyEditHasHighSpeedInternetV2RequestDto,
  UserPropertyEditHasHotTubV2RequestDto,
  UserPropertyEditHasHotWaterUtilityIncludedV2RequestDto,
  UserPropertyEditHasIntercomSecurityV2RequestDto,
  UserPropertyEditHasInternetUtilityIncludedV2RequestDto,
  UserPropertyEditHasLaminateFloorCoveringV2RequestDto,
  UserPropertyEditHasLawnOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasLessThanOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasLibraryCommunityRoomV2RequestDto,
  UserPropertyEditHasLinoleumFloorCoveringV2RequestDto,
  UserPropertyEditHasLoungeCommunityRoomV2RequestDto,
  UserPropertyEditHasMicrowaveOvenApplianceV2RequestDto,
  UserPropertyEditHasMonthlyLeaseLengthsV2RequestDto,
  UserPropertyEditHasMoreThanOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasMountainViewV2RequestDto,
  UserPropertyEditHasMultiLevelGarageParkingV2RequestDto,
  UserPropertyEditHasMultiPurposeSportCourtV2RequestDto,
  UserPropertyEditHasNightPatrolSecurityV2RequestDto,
  UserPropertyEditHasNoneLeaseLengthsV2RequestDto,
  UserPropertyEditHasNoneParkingV2RequestDto,
  UserPropertyEditHasOilHeatingSourceV2RequestDto,
  UserPropertyEditHasOneYearLeaseLengthsV2RequestDto,
  UserPropertyEditHasOnlineMaintenancePortalV2RequestDto,
  UserPropertyEditHasOnlineRentPaymentV2RequestDto,
  UserPropertyEditHasOnsiteManagementV2RequestDto,
  UserPropertyEditHasOtherSportCourtV2RequestDto,
  UserPropertyEditHasOvenApplianceV2RequestDto,
  UserPropertyEditHasPackageServiceV2RequestDto,
  UserPropertyEditHasParkingLotParkingV2RequestDto,
  UserPropertyEditHasParkViewV2RequestDto,
  UserPropertyEditHasPartyRoomCommunityRoomV2RequestDto,
  UserPropertyEditHasPatioBalconyV2RequestDto,
  UserPropertyEditHasPatioOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPetParkV2RequestDto,
  UserPropertyEditHasPetWashingStationCommunityRoomV2RequestDto,
  UserPropertyEditHasPicnicAreaOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPlaygroundOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasPropaneButaneHeatingSourceV2RequestDto,
  UserPropertyEditHasRacquetballSportCourtV2RequestDto,
  UserPropertyEditHasRangeApplianceV2RequestDto,
  UserPropertyEditHasRefrigeratorApplianceV2RequestDto,
  UserPropertyEditHasRooftopDeckOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasSatelliteTvV2RequestDto,
  UserPropertyEditHasSaunaV2RequestDto,
  UserPropertyEditHasSewageUtilityIncludedV2RequestDto,
  UserPropertyEditHasShuffleboardSportCourtV2RequestDto,
  UserPropertyEditHasSixMonthsLeaseLengthsV2RequestDto,
  UserPropertyEditHasSlateFloorCoveringV2RequestDto,
  UserPropertyEditHasSoftwoodFloorCoveringV2RequestDto,
  UserPropertyEditHasSolarHeatingSourceV2RequestDto,
  UserPropertyEditHasSpanishSpeakingStaffV2RequestDto,
  UserPropertyEditHasSportsFieldSportCourtV2RequestDto,
  UserPropertyEditHasStorageSpaceV2RequestDto,
  UserPropertyEditHasSwimmingPoolV2RequestDto,
  UserPropertyEditHasTennisSportCourtV2RequestDto,
  UserPropertyEditHasTerritorialViewV2RequestDto,
  UserPropertyEditHasTheaterCommunityRoomV2RequestDto,
  UserPropertyEditHasTileFloorCoveringV2RequestDto,
  UserPropertyEditHasTrailOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasTrashCompactorApplianceV2RequestDto,
  UserPropertyEditHasTwentyFourHourMaintenanceV2RequestDto,
  UserPropertyEditHasUndergroundGarageParkingV2RequestDto,
  UserPropertyEditHasValetTrashV2RequestDto,
  UserPropertyEditHasVinylFloorCoveringV2RequestDto,
  UserPropertyEditHasVolleyballSportCourtV2RequestDto,
  UserPropertyEditHasWallAirConditioningV2RequestDto,
  UserPropertyEditHasWasherDryerHookupsApplianceV2RequestDto,
  UserPropertyEditHasWaterFeatureOutDoorCommonAreaV2RequestDto,
  UserPropertyEditHasWaterUtilityIncludedV2RequestDto,
  UserPropertyEditHasWaterViewV2RequestDto,
  UserPropertyEditHasWindowAirConditioningV2RequestDto,
  UserPropertyEditHasWoodedViewV2RequestDto,
  UserPropertyEditIsFurnishedV2RequestDto,
  UserPropertyEditIsOver55V2RequestDto,
  UserPropertyEditSmokingAllowedV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Args {
  postData: UserPropertyEditHasAirConditioningUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAirConditioningUtilityIncluded(
        args.postData,
        httpClient,
      ),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Args {
  postData: UserPropertyEditHasAssistedLivingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAssistedLiving(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Args {
  postData: UserPropertyEditHasAttachedGarageParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasAttachedGarageParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Args {
  postData: UserPropertyEditHasBarbecueV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBarbecue(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Args {
  postData: UserPropertyEditHasBasketballSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBasketballSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Args {
  postData: UserPropertyEditHasBicycleStorageV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBicycleStorage(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Args {
  postData: UserPropertyEditHasBocceSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBocceSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Args {
  postData: UserPropertyEditHasBuildingWideWirelessV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBuildingWideWireless(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Args {
  postData: UserPropertyEditHasBusinessCenterCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasBusinessCenterCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Args {
  postData: UserPropertyEditHasCableTvV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTv(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Args {
  postData: UserPropertyEditHasCableTvUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCableTvUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Args {
  postData: UserPropertyEditHasCarpetFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCarpetFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Args {
  postData: UserPropertyEditHasCeilingFanV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCeilingFan(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Args {
  postData: UserPropertyEditHasCentralAirConditioningV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCentralAirConditioning(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Args {
  postData: UserPropertyEditHasCityViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCityView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Args {
  postData: UserPropertyEditHasClubHouseCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasClubHouseCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Args {
  postData: UserPropertyEditHasConcreteFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConcreteFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Args {
  postData: UserPropertyEditHasConferenceRoomCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConferenceRoomCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Args {
  postData: UserPropertyEditHasControlledAccessSecurityV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasControlledAccessSecurity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Args {
  postData: UserPropertyEditHasConvectionOvenApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasConvectionOvenAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Args {
  postData: UserPropertyEditHasCoveredParkingParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasCoveredParkingParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Args {
  postData: UserPropertyEditHasDeckOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDeckOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Args {
  postData: UserPropertyEditHasDetachedGarageParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDetachedGarageParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Args {
  postData: UserPropertyEditHasDisabledAccessV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDisabledAccess(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Args {
  postData: UserPropertyEditHasDishwasherApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDishwasherAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Args {
  postData: UserPropertyEditHasDoormanSecurityV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoormanSecurity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Args {
  postData: UserPropertyEditHasDoubleOvenApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDoubleOvenAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Args {
  postData: UserPropertyEditHasDryCleaningDropOffV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasDryCleaningDropOff(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Args {
  postData: UserPropertyEditHasElectricHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Args {
  postData: UserPropertyEditHasElectricityUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElectricityUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Args {
  postData: UserPropertyEditHasElevatorV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasElevator(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Args {
  postData: UserPropertyEditHasFireplaceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFireplace(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Args {
  postData: UserPropertyEditHasFitnessCenterCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFitnessCenterCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Args {
  postData: UserPropertyEditHasFlexibleLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFlexibleLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Args {
  postData: UserPropertyEditHasFreezerApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasFreezerAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Args {
  postData: UserPropertyEditHasGameRoomCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGameRoomCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Args {
  postData: UserPropertyEditHasGarbageDisposalApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageDisposalAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Args {
  postData: UserPropertyEditHasGarbageUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGarbageUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Args {
  postData: UserPropertyEditHasGardenOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGardenOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Args {
  postData: UserPropertyEditHasGasHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Args {
  postData: UserPropertyEditHasGasUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGasUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Args {
  postData: UserPropertyEditHasGatedEntrySecurityV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGatedEntrySecurity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Args {
  postData: UserPropertyEditHasGazeboOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGazeboOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Args {
  postData: UserPropertyEditHasGolfCourseViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGolfCourseView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Args {
  postData: UserPropertyEditHasGuestSuiteV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasGuestSuite(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Args {
  postData: UserPropertyEditHasHardwoodFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHardwoodFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Args {
  postData: UserPropertyEditHasHeatingUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatingUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Args {
  postData: UserPropertyEditHasHeatPumpHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHeatPumpHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Args {
  postData: UserPropertyEditHasHighSpeedInternetV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHighSpeedInternet(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Args {
  postData: UserPropertyEditHasHotTubV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotTub(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Args {
  postData: UserPropertyEditHasHotWaterUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasHotWaterUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Args {
  postData: UserPropertyEditHasIntercomSecurityV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasIntercomSecurity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Args {
  postData: UserPropertyEditHasInternetUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasInternetUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Args {
  postData: UserPropertyEditHasLaminateFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLaminateFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Args {
  postData: UserPropertyEditHasLawnOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLawnOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Args {
  postData: UserPropertyEditHasLessThanOneYearLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLessThanOneYearLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Args {
  postData: UserPropertyEditHasLibraryCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLibraryCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Args {
  postData: UserPropertyEditHasLinoleumFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLinoleumFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Args {
  postData: UserPropertyEditHasLoungeCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasLoungeCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Args {
  postData: UserPropertyEditHasMicrowaveOvenApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMicrowaveOvenAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Args {
  postData: UserPropertyEditHasMonthlyLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMonthlyLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Args {
  postData: UserPropertyEditHasMoreThanOneYearLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMoreThanOneYearLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Args {
  postData: UserPropertyEditHasMountainViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMountainView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Args {
  postData: UserPropertyEditHasMultiLevelGarageParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiLevelGarageParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Args {
  postData: UserPropertyEditHasMultiPurposeSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasMultiPurposeSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Args {
  postData: UserPropertyEditHasNightPatrolSecurityV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNightPatrolSecurity(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Args {
  postData: UserPropertyEditHasNoneLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Args {
  postData: UserPropertyEditHasNoneParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasNoneParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Args {
  postData: UserPropertyEditHasOilHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOilHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Args {
  postData: UserPropertyEditHasOneYearLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOneYearLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Args {
  postData: UserPropertyEditHasOnlineMaintenancePortalV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineMaintenancePortal(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Args {
  postData: UserPropertyEditHasOnlineRentPaymentV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnlineRentPayment(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Args {
  postData: UserPropertyEditHasOnsiteManagementV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOnsiteManagement(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Args {
  postData: UserPropertyEditHasOtherSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOtherSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Args {
  postData: UserPropertyEditHasOvenApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasOvenAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Args {
  postData: UserPropertyEditHasPackageServiceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPackageService(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Args {
  postData: UserPropertyEditHasParkingLotParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkingLotParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Args {
  postData: UserPropertyEditHasParkViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasParkView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Args {
  postData: UserPropertyEditHasPartyRoomCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPartyRoomCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Args {
  postData: UserPropertyEditHasPatioBalconyV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioBalcony(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Args {
  postData: UserPropertyEditHasPatioOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPatioOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Args {
  postData: UserPropertyEditHasPetParkV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetPark(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Args {
  postData: UserPropertyEditHasPetWashingStationCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPetWashingStationCommunityRoom(
        args.postData,
        httpClient,
      ),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Args {
  postData: UserPropertyEditHasPicnicAreaOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPicnicAreaOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Args {
  postData: UserPropertyEditHasPlaygroundOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPlaygroundOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Args {
  postData: UserPropertyEditHasPropaneButaneHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasPropaneButaneHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Args {
  postData: UserPropertyEditHasRacquetballSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRacquetballSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Args {
  postData: UserPropertyEditHasRangeApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRangeAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Args {
  postData: UserPropertyEditHasRefrigeratorApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRefrigeratorAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Args {
  postData: UserPropertyEditHasRooftopDeckOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasRooftopDeckOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Args {
  postData: UserPropertyEditHasSatelliteTvV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSatelliteTv(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Args {
  postData: UserPropertyEditHasSaunaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSauna(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Args {
  postData: UserPropertyEditHasSewageUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSewageUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Args {
  postData: UserPropertyEditHasShuffleboardSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasShuffleboardSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Args {
  postData: UserPropertyEditHasSixMonthsLeaseLengthsV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSixMonthsLeaseLengths(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Args {
  postData: UserPropertyEditHasSlateFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSlateFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Args {
  postData: UserPropertyEditHasSoftwoodFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSoftwoodFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Args {
  postData: UserPropertyEditHasSolarHeatingSourceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSolarHeatingSource(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Args {
  postData: UserPropertyEditHasSpanishSpeakingStaffV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSpanishSpeakingStaff(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Args {
  postData: UserPropertyEditHasSportsFieldSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSportsFieldSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Args {
  postData: UserPropertyEditHasStorageSpaceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasStorageSpace(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Args {
  postData: UserPropertyEditHasSwimmingPoolV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasSwimmingPool(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Args {
  postData: UserPropertyEditHasTennisSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTennisSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Args {
  postData: UserPropertyEditHasTerritorialViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTerritorialView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Args {
  postData: UserPropertyEditHasTheaterCommunityRoomV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTheaterCommunityRoom(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Args {
  postData: UserPropertyEditHasTileFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTileFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Args {
  postData: UserPropertyEditHasTrailOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrailOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Args {
  postData: UserPropertyEditHasTrashCompactorApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTrashCompactorAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Args {
  postData: UserPropertyEditHasTwentyFourHourMaintenanceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasTwentyFourHourMaintenance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Args {
  postData: UserPropertyEditHasUndergroundGarageParkingV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasUndergroundGarageParking(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Args {
  postData: UserPropertyEditHasValetTrashV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasValetTrash(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Args {
  postData: UserPropertyEditHasVinylFloorCoveringV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVinylFloorCovering(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Args {
  postData: UserPropertyEditHasVolleyballSportCourtV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasVolleyballSportCourt(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Args {
  postData: UserPropertyEditHasWallAirConditioningV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWallAirConditioning(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Args {
  postData: UserPropertyEditHasWasherDryerHookupsApplianceV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWasherDryerHookupsAppliance(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Args {
  postData: UserPropertyEditHasWaterFeatureOutDoorCommonAreaV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Options =
  UseMutationOptions<
    void,
    unknown,
    RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Args
  >;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea = ({
  httpClient,
  ...options
}: Omit<
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterFeatureOutDoorCommonArea(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Args {
  postData: UserPropertyEditHasWaterUtilityIncludedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterUtilityIncluded(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Args {
  postData: UserPropertyEditHasWaterViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWaterView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Args {
  postData: UserPropertyEditHasWindowAirConditioningV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWindowAirConditioning(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Args {
  postData: UserPropertyEditHasWoodedViewV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_hasWoodedView(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Args {
  postData: UserPropertyEditIsFurnishedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isFurnished(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Args {
  postData: UserPropertyEditIsOver55V2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55 = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_isOver55(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Args {
  postData: UserPropertyEditSmokingAllowedV2RequestDto;
}

export type RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Args
>;

export const useRentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed_Args) =>
      RentalManagerUserPropertyEditAmenitiesV2WebApiHandler_smokingAllowed(args.postData, httpClient),
  });
};
